import service from "@/utils/request";

// 获取支付方式列表
export const getPayment = () => {
  return service({
    url: "/api/v1/order/payment/list",
    method: "get",
  });
};

// 订单列表
interface orderListData {
  page?: number;
  page_size?: number;
  student_key_word?: string;
  order_no?: string;
  belong?: number;
  create_time_start?: string;
  create_time_end?: string;
  payment_status?: number;
  status?: number;
}
export const orderList = (data: orderListData) => {
  return service({
    url: "/api/v1/order/list",
    method: "post",
    data,
  });
};

// 创建订单（报名/续费）
interface createOrderData {
  student_id: number;
  combo: {
    combo_product_id: number;
    item: {
      option_id: number;
      quantity: string;
      discount_type: number;
      discount: string;
      give_quantity: string;
    }[];
  };
  course: {
    course_id: number;
    option_id: number;
    quantity: string;
    discount_type: number;
    discount: string;
    give_quantity: string;
  }[];
  payment_methods: {
    payment_method_id: number;
    amount: string;
  }[];
  order_belong: number[];
  remark: string;
}
export const createOrder = (data: createOrderData) => {
  return service({
    url: "/api/v1/order/create",
    method: "post",
    data,
  });
};

// 订单详情
interface orderDetailData {
  order_id: number;
}
export const orderDetail = (params: orderDetailData) => {
  return service({
    url: "/api/v1/order/detail",
    method: "get",
    params,
  });
};

// 废除订单检查
interface checkOrderCostData {
  order_id: number;
}
export const checkOrderCost = (params: checkOrderCostData) => {
  return service({
    url: "/api/v1/order/consume/detail",
    method: "get",
    params,
  });
};

// 废除订单
interface abolishOrderData {
  order_id: number;
  remark: string;
}
export const abolishOrder = (data: abolishOrderData) => {
  return service({
    url: "/api/v1/order/abolish",
    method: "post",
    data,
  });
};

// 学员-我的订单
interface studentOrderData {
  page: number;
  page_size: number;
  student_id: number;
}
export const studentOrder = (params: studentOrderData) => {
  return service({
    url: "/api/v1/order/student/item",
    method: "get",
    params,
  });
};

// 订单详情导出
interface exportOrderDetailData {
  order_id: number;
}
export const exportOrderDetailApi = (params: exportOrderDetailData) => {
  return service({
    url: "/api/v1/order/detail/export",
    method: "get",
    params,
  });
};
// 退课、转课订单详情
interface expendItemDetailData {
  item_ids: number[];
  student_id: number;
}
export const expendItemDetailApi = (data: expendItemDetailData) => {
  return service({
    url: "/api/v1/order/expend/item_detail",
    method: "post",
    data,
  });
};

// 退课
export interface lessonRefundData {
  student_id: number;
  items: {
    item_id: number;
    refund_quantity: string;
    should_refund_amount: string;
    handling_fee: string;
  }[];
  payment_methods?: {
    amount: string;
    payment_method_id: number;
  }[];
  refund_transfer?: {
    bank_name: string;
    bank_card: string;
    open_bank: string;
    card_holder_name: string;
  };
  remark: string;
  handle_time: string;
  order_belong?: number[];
}
export const lessonRefundApi = (data: lessonRefundData) => {
  return service({
    url: "/api/v1/order/refund",
    method: "post",
    data,
  });
};
// 转课
export interface lessonTransferData {
  student_id: number;
  transfer_item: {
    refund_quantity: string;
    should_refund_amount: string;
    handling_fee: string;
    item_id: number;
  };
  buy_course: {
    course_id: number;
    option_id: number;
    quantity: string;
    discount_type: number;
    discount: string;
    give_quantity: string;
    effective_time: string;
  }[];
  class_arrangement?: {
    class_id: number;
    course_id: number;
  }[];
  old_data_repair?: number;
  payment_methods?: {
    amount: string;
    payment_method_id: number;
  }[];
  remark: string;
  handle_time: string;
  order_belong?: number[];
  transfer_join_student_id: number;
}
export const lessonTransferApi = (data: lessonTransferData) => {
  return service({
    url: "/api/v1/order/transfer",
    method: "post",
    data,
  });
};
// 订单列表（明细）实收退统计
interface orderTatisticsData {
  student_key_word?: string;
  student_id?: number;
  order_no?: string;
  belong?: number;
  create_time_start?: string;
  create_time_end?: string;
  payment_type?: number;
  status?: number;
  create_staff_id?: number;
  order_type?: number;
  course_id?: number;
  order_type_arr?: number[];
  approval_status_arr?: number[];
  handle_time_start?: string;
  handle_time_end?: string;
  subject_id?: number;
  business_type?: number[];
}
// 订单列表实收退统计
export const orderTatisticsApi = (data: orderTatisticsData) => {
  return service({
    url: "/api/v1/order/list/statistics",
    method: "post",
    data,
  });
};
// 订单明细列表实收退统计
export const orderItemStatisticsApi = (data: orderTatisticsData) => {
  return service({
    url: "/api/v1/order/item/statistics",
    method: "post",
    data,
  });
};
// 订单列表（明细）实收退统计
interface orderitemListData {
  page: number;
  page_size: number;
  order_no?: string;
  order_type?: number;
  student_key_word?: string;
  create_staff_id?: number;
  belong?: number;
  course_id?: number;
  create_time_start?: number;
  create_time_end?: number;
  subject_id?: number;
}
export const orderitemListApi = (data: orderitemListData) => {
  return service({
    url: "/api/v1/order/item/list",
    method: "post",
    data,
  });
};
// 更换支付方式
interface changePaymentTypeData {
  order_id: number;
  payment_methods: {
    payment_method_id: number;
    amount: string;
  }[];
  handle_time?: string;
  auth_code?: string;
  remark?: string;
}
export const changePaymentTypeApi = (data: changePaymentTypeData) => {
  return service({
    url: "/api/v1/order/change_pay_type",
    method: "post",
    data,
  });
};
// 查看订单是否完成
interface checkFinishData {
  order_payment_id: number;
}
export const checkFinishApi = (params: checkFinishData) => {
  return service({
    url: "/api/v1/order/pay/check_finish",
    method: "get",
    params,
  });
};
// 取消支付
interface orderCancelData {
  order_id: number;
}
export const orderCancelApi = (data: orderCancelData) => {
  return service({
    url: "/api/v1/order/cancel",
    method: "post",
    data,
  });
};
// 取消退款订单
interface refundOrderCancelData {
  refund_order_id: number;
}
export const refundOrderCancelApi = (data: refundOrderCancelData) => {
  return service({
    url: "/api/v1/order/refund/cancel",
    method: "post",
    data,
  });
};
// 收款记录
export interface getOrderCollectionListData {
  page: number;
  page_size: number;
  biz_id?: string;
  order_no?: string;
  trade_start_time?: string;
  trade_end_time?: string;
  student_id?: number;
  term_type?: number;
  payment_form?: number;
  provider_type?: number;
  status?: number;
}
export const getOrderCollectionListApi = (
  params: getOrderCollectionListData
) => {
  return service({
    url: "/api/v1/order/collection/list",
    method: "get",
    params,
  });
};
// 收款记录统计
export const getOrderCollectionStatisticsApi = (
  params: getOrderCollectionListData
) => {
  return service({
    url: "/api/v1/order/collection/amount_statistics",
    method: "get",
    params,
  });
};
// 原路回退
export interface refundOriginalBackData {
  refund_order_id: number;
}
export const refundOriginalBackApi = (data: refundOriginalBackData) => {
  return service({
    url: "/api/v1/order/refund/original_back",
    method: "post",
    data,
  });
};
// 手动转账退款
export interface refundTransferHandData {
  refund_order_id: number;
  bank_name: string;
  bank_card: string;
  open_bank: string;
  card_holder_name: string;
}
export const refundTransferHandApi = (data: refundTransferHandData) => {
  return service({
    url: "/api/v1/order/refund/transfer_hand",
    method: "post",
    data,
  });
};
// 查看退款是否完成
export interface checkRefundStatusData {
  refund_order_id: number;
}
export const checkRefundStatusApi = (params: checkRefundStatusData) => {
  return service({
    url: "/api/v1/order/refund/check_status",
    method: "get",
    params,
  });
};
// 上传转账凭证
export interface uploadRefundVoucherData {
  refund_order_id: number;
  voucher: string;
}
export const uploadRefundVoucherApi = (data: uploadRefundVoucherData) => {
  return service({
    url: "/api/v1/order/refund/transfer_hand_confirm",
    method: "post",
    data,
  });
};

// 订单编辑
interface approvalRejectEditData {
  order_id: number;
  item_list: [
    order_item_id: number,
    give_quantity: string,
    effective_time: string
  ];
  order_belong: any[];
  remark: string;
}
export const approvalRejectEditApi = (data: approvalRejectEditData) => {
  return service({
    url: "/api/v1/order/approval_reject_edit",
    method: "post",
    data,
  });
};
// 收款记录导出
export interface exportOrderCollectionListData {
  biz_id?: string;
  order_no?: string;
  trade_start_time?: string;
  trade_end_time?: string;
  student_id?: number;
  term_type?: number;
  payment_form?: number;
  provider_type?: number;
}
export const exportOrderCollectionListApi = (
  params: exportOrderCollectionListData
) => {
  return service({
    url: "/api/v1/order/collection/list_export",
    method: "get",
    params,
  });
};
// 退款明细
export interface refundDetailData {
  pay_order_no?: string;
}
export const refundDetailApi = (params: refundDetailData) => {
  return service({
    url: "/api/v1/order/refund/detail",
    method: "get",
    params,
  });
};

// 提交收款机客户码
export const sendPayCodeApi = (data: {
  order_id: number;
  auth_code: string;
}) => {
  return service({
    url: "/api/v1/order/micro_pay/auth_code_receive",
    method: "post",
    data,
  });
};

// 支付明细
export const getPaymentDetailApi = (params: { order_id: number }) => {
  return service({
    url: "/api/v1/order/payment/success_details_list",
    method: "get",
    params,
  });
};

// 获取汇付支付链接（H5项目支付页）
export const getHuifuPaymentUrlApi = (params: {
  order_id: number;
  payer_amount: string;
}) => {
  return service({
    url: "/api/v1/order/payment/scan_url",
    method: "get",
    params,
  });
};

// 退款列表
interface paymentRefundParamsI {
  page?: number;
  page_size?: number;
  sort_field?: string;
  sort_type?: string;
  refund_no?: string;
  trade_time_1?: string;
  trade_time_2?: string;
  biz_id?: string;
}
export const getPaymentRefundLogApi = (params: paymentRefundParamsI) => {
  return service({
    url: "/api/v1/payment/refund/list",
    method: "get",
    params,
  });
};

// 退款列表导出
export const exportPaymentRefundLogApi = (data: paymentRefundParamsI) => {
  return service({
    url: "/api/v1/payment/refund/list/export",
    method: "post",
    data,
  });
};
